import React from 'react';

export default function Button({ type = type || 'submit', className = '', processing, opacityWhileProcessing = true, value, onClick, dataTestid, children }) {
    return (
        <button
            type={type}
            className={
                ` ${
                    processing && opacityWhileProcessing ? 'opacity-25' : 'opacity-100'
                } ` + className
            }
            disabled={processing}
            value={value}
            onClick={onClick}
            data-testid={dataTestid}
        >
            {children}
        </button>
    );
}
